import React from 'react';
import { withRouter } from 'react-router';
import * as Render from '../../platformui/Base/Render';
import Section from '../../platformui/Section';
import NewsPush from '../../components/news-push';

import ManuelPageListBlock from '../../blocks/manuel-page-list-block';
import EntryBlock from '../../blocks/entry-block';
import ContentHistoryBlock from '../../blocks/content-history-block';
import SurveyBlock from '../../blocks/survey-block';
import { isSmallViewport } from '../../platformui/Hooks/useMedia';
import classNames from 'classnames';

const Blocks = {
  ManuelPageListBlock,
  EntryBlock,
  ContentHistoryBlock,
  SurveyBlock,
};

const StartPage = (props) => {
  const isSurveyBlock =
    props.Content.RelatedContent && props.Content.RelatedContent.filter(
      (i) => i.BlockTypeName === 'SurveyBlock' && i
    ).length > 0;

  const surveyClasses = classNames({
    columns: true,
    'small-12': isSmallViewport(),
    'large-3': !isSmallViewport(),
    'u-float-top-3': !isSmallViewport() && isSurveyBlock,
    'u-float-top-4': !isSmallViewport() && !isSurveyBlock,
  });

  const newsClasses = classNames({
    columns: true,
    'small-12': true,
    'large-9': !isSmallViewport() && isSurveyBlock,
  });

  const relatedContentId = isSmallViewport()
    ? 'RelatedContent__Small12'
    : 'RelatedContent__Large3';

  return (
    <main id="content" className="main--preload">
      <h1 className="show-for-sr">{props.Content.Heading}</h1>
      <div className="main">
        {props.Content.EntryHeading && (
          <h2 className="show-for-sr">{props.Content.EntryHeading}</h2>
        )}
        <Render.Block
          blocks={props.Content.EntryContent}
          propertyName="EntryContent"
          currentPageProps={props}
        >
          <Render.BlockTypeRenderer Blocks={Blocks} />
        </Render.Block>
      </div>

      <Section Modifiers={{ 'c-section--primary-intro': true }}>
        <div className="row">
          <div className="small-12 large-9 columns">
            <div className="row columns">
              {props.Content.IntroHeading && (
                <h2 className="show-for-sr">{props.Content.IntroHeading}</h2>
              )}
              <Render.Block
                blocks={
                  props.Content.IntroContent &&
                    props.Content.IntroContent.length > 1
                    ? props.Content.IntroContent[0]
                    : props.Content.IntroContent
                }
                propertyName="IntroContent"
                currentPageProps={props}
              >
                <Render.BlockTypeRenderer Blocks={Blocks} />
              </Render.Block>
            </div>
          </div>
          <div className={newsClasses}>
            <div className="row">
              <NewsPush {...props} />
            </div>
          </div>

          <div className={surveyClasses}>
            <Render.Block
              Modifiers={{ 'content-history--start-page': true }}
              blocks={props.Content.RelatedContent}
              propertyName="RelatedContent"
              lastListItemId={relatedContentId}
              currentPageProps={props}
            >
              <Render.BlockTypeRenderer Blocks={Blocks} />
            </Render.Block>
          </div>
        </div>
      </Section>

      <div className="main">
        {props.Content.SectionHeading && (
          <h2 className="show-for-sr">{props.Content.SectionHeading}</h2>
        )}
        <Render.Block
          blocks={props.Content.SectionContent}
          propertyName="SectionContent"
          currentPageProps={props}
        >
          <Render.BlockTypeRenderer Blocks={Blocks} />
        </Render.Block>
      </div>
    </main>
  );
};

export default withRouter(StartPage);